export function svgPoint(evt: { clientX: number; clientY: number }, svgEl: SVGSVGElement): { x: number; y: number } {
  const m = svgEl.getScreenCTM()!.inverse();
  const p = new DOMPoint(evt.clientX, evt.clientY).matrixTransform(m);
  return { x: p.x, y: p.y };
}
